import fieldStateEnum from '@src/utils/enums/fieldStateEnum';
import { SbValidator } from '@src/components/Form/utils/validator';

export default {
  data: () => ({
    internalValidator: new SbValidator(),
  }),
  mounted() {
    this.$el.submit = this.submit;
    this.$el.validateAndSubmit = this.validateAndSubmit;
    if (this.enableValidator) {
      this.internalValidator.setupValidator(this.validator);
      const validator = this.internalValidator;
      // eslint-disable-next-line no-restricted-syntax
      for (const key in this.sbForm.fields) {
        if (validator.hasValidationFor(key)) {
          this.$watch(`sbForm.fields.${key}`, (val) => {
            const validationObj = validator.validate(key, val, this.getData());
            this.internalValidator.validations[key] = validationObj;
            this.$emit('onChangeValidated', this.generateValidatedData());
          }, { immediate: !!validator.validateImmediate, deep: true });
        }
      }
    } else {
      // null out Validator class if we aren't going to use it.
      this.internalValidator = null;
    }
    if (this.model) {
      this.$nextTick(() => {
        this.$watch('model', this.setFormData, { immediate: true });
      });
    }
  },
  computed: {
    enableValidator() {
      return this.validator && !this.useDefaultValiations;
    },
    validations() {
      return this.internalValidator.validations;
    },
  },
  methods: {
    onChange(eventData) {
      this.$emit('onChange', eventData);
      this.$emit('form-changed', this.getData());
      this.$emit('onChangeValidated', this.generateValidatedData());
    },
    setFormData() {
    // eslint-disable-next-line no-restricted-syntax, guard-for-in
      for (const key in this.sbForm.fields) {
        this.sbForm.fields[key].value = this.model[key];
      }
    },
    getData() {
      const data = {};
      // eslint-disable-next-line no-restricted-syntax, guard-for-in
      for (const key in this.sbForm.fields) {
        data[key] = this.sbForm.fields[key].value;
      }
      return data;
    },
    setFieldsToSubmit() {
      // eslint-disable-next-line no-restricted-syntax, guard-for-in
      for (const key in this.sbForm.fields) {
        const field = this.sbForm.fields[key];
        field.state = fieldStateEnum.submit;
        if (this.internalValidator.hasValidationFor(key)) this.internalValidator.validate(key, field, this.getData());
      }
    },
    generateValidatedData() {
      const isValid = this.internalValidator.valid;
      const data = this.getData();
      return {
        validations: this.internalValidator.validations,
        valid: isValid,
        data,
      };
    },
    submit(e) {
      if (e) {
        e.preventDefault();
      }
      this.setFieldsToSubmit();
      const toReturn = this.generateValidatedData();
      this.$emit('onsubmit', toReturn);
      return toReturn;
    },
    validateAndSubmit(e) {
      return this.submit(e);
    },
  },
};
